import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCar = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="M6.75 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM17.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
      <path
        d="m7.103 2-.18.005A3 3 0 0 0 4.18 4.32l-1.049 4.5.08-.042A4 4 0 0 0 1 12.355V17l.005.164a2.5 2.5 0 0 0 2.33 2.33l.207.006.003.02A3 3 0 0 0 6.5 22l.176-.005a3.002 3.002 0 0 0 2.743-2.3l.039-.195h5.084l.003.02A3.002 3.002 0 0 0 17.501 22l.176-.005a3.003 3.003 0 0 0 2.744-2.3l.038-.195h.041A2.5 2.5 0 0 0 23 17v-4.646l-.006-.215a4 4 0 0 0-2.015-3.261l-.105-.056-.999-4.476A3 3 0 0 0 16.947 2H7.103Zm0 2h9.844a1 1 0 0 1 .976.782l1.103 4.937a1 1 0 0 0 .528.676l.34.17A2 2 0 0 1 21 12.355V17a.5.5 0 0 1-.5.5h-.998a1 1 0 0 0-1 1v.5a1 1 0 0 1-2.002 0v-.5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v.5a1 1 0 1 1-2 0v-.5a1 1 0 0 0-1-1h-1A.5.5 0 0 1 3 17v-4.645a2 2 0 0 1 1.106-1.79l.341-.17a1 1 0 0 0 .527-.667L6.13 4.773A1 1 0 0 1 7.103 4Z"
        fillRule="nonzero"
      />
      <path
        d="M15.198 5.5H8.802A2 2 0 0 0 6.85 7.066l-.826 3.717A1 1 0 0 0 7 12h10a1 1 0 0 0 .976-1.217l-.826-3.717A2 2 0 0 0 15.198 5.5Zm.555 4.5H8.246l.556-2.5h6.395l.556 2.5Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgCar)
const Memo = memo(ForwardRef)
export default Memo
